// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2bzdw","content":"ManualTimeModal_content__1elSn"};